import { render, staticRenderFns } from "./shopClassification.vue?vue&type=template&id=67df384c&scoped=true&"
import script from "./shopClassification.vue?vue&type=script&lang=js&"
export * from "./shopClassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67df384c",
  null
  
)

export default component.exports